export default __webpack_public_path__ + "static/media/IN500_logo.a4fe524d.png";